export default "__VITE_ASSET__UOMZaIcP__"